var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuplicateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1663 11.9444V3.05547C19.1663 2.4661 18.9322 1.90087 18.5155 1.48413C18.0987 1.06738 17.5335 0.833252 16.9441 0.833252H8.05523C7.46586 0.833252 6.90063 1.06738 6.48388 1.48413C6.06713 1.90087 5.83301 2.4661 5.83301 3.05547V11.9444C5.83301 12.5337 6.06713 13.099 6.48388 13.5157C6.90063 13.9325 7.46586 14.1666 8.05523 14.1666H16.9441C17.5335 14.1666 18.0987 13.9325 18.5155 13.5157C18.9322 13.099 19.1663 12.5337 19.1663 11.9444Z",
    stroke: "#0e0333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55523 5.83325H3.19412C2.56791 5.83325 1.96736 6.06744 1.52456 6.48429C1.08177 6.90114 0.833008 7.46651 0.833008 8.05603V16.9438C0.833008 17.5333 1.08177 18.0987 1.52456 18.5155C1.96736 18.9324 2.56791 19.1666 3.19412 19.1666H3.19766L12.6421 19.151C13.2677 19.1501 13.8673 18.9156 14.3094 18.4988C14.7514 18.0821 14.9997 17.5172 14.9997 16.9282V14.7244",
    stroke: "#0e0333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4995 4.1665V10.8332",
    stroke: "#0e0333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8332 7.5H9.1665",
    stroke: "#0e0333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateIcon);
export default __webpack_public_path__ + "static/media/duplicate-icon.ad4ff2ca0114c6abd9a03392b0168f54.svg";
export { ForwardRef as ReactComponent };